import { writable } from "svelte/store";
import { call } from "$lib/Api/Api.svelte";

const interactions = writable([]);

const interactionStore = {
  subscribe: interactions.subscribe,
  load: (id) => {
    return call("interactions", "query")
      .then((data) => {
        interactions.set(data);
      })
      .catch((err) => {});
  },
};

export default interactionStore;
